/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
app.controller('a_loginCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'AtlasNotification', 'LoginService', 'ConfigService','$timeout', function($rootScope, $scope, $http, networkService, MainService, AtlasNotification, LoginService, ConfigService, $timeout) {
    $scope.showEmailHint = false;
    $scope.showCredentials = false;
    $scope.showResendHint = false;

    $scope.gui = {};
    $scope.gui.loginButton = { disabled: false };
    $scope.gui.tfa = { visible: false };
    $scope.gui.password = { disabled: false };
    $scope.gui.email = { disabled: false };
    $scope.gui.view = {};
    $scope.gui.view.visible = true;

    $scope.state = 1; //1 = normal; 2 = tfa
    
    $rootScope.$on("login_view", function(e, data){
        if(data.cmd == "open"){
            $scope.gui.view.visible = true;
        }
    })
    
    function checkCredentials() {
        $scope.credentials = LoginService.getCredentials()

        if ($scope.credentials != null) {
            $(document).ready(function() {
                $("#loginHeadButon a").click()
            })
            $rootScope.$emit("showCredentials", $scope.credentials)

        }

    }
    
    $scope.showPasswordForgottView = function(){
         $scope.gui.view.visible = false;
        $rootScope.$emit("passwordReset_view", {cmd: "open"});
    }

    $scope.showRegisterView = function(){
        $scope.gui.view.visible = false;
        $rootScope.$emit("register_view", {cmd: "open"});
    }
    
    $scope.checkUrlForRegisterView = function(){
        return window.location.href.split("#").pop() == "register";
    }
    
    if($scope.checkUrlForRegisterView()){
        $timeout(function(){
            $scope.showRegisterView()
        },200)
         
    }
    
    
    $scope.inputChanged = function() {}

    $scope.resendApproveEmail = function() {
        networkService.resendApproveEmail($scope.credentials.email, function() {

        })
    }

    $scope.init = function() {
        var config = ConfigService.get("animateLogin")
        if (config == null) {
            ConfigService.set("animateLogin", "true")
            setTimeout(function() {
                $("#loginText").velocity({ textShadowBlur: "20px" }, {
                    ease: "ease-in",
                    duration: 500,
                    complete: function() {
                        $("#loginText").velocity({ textShadowBlur: "0px" }, { ease: "ease-out", duration: 200 }, 100)
                    }
                }, 100)
            }, 5000)

        }
        else {

        }
    }




    $scope.openForgottPasswordDialog = function() {
        console.log("forgot password dialog")
    }

    $scope.ignoreCredentials = function() {
        $scope.showCredentials = false;
    }

    $scope.loginWithCredentials = function() {
        networkService.checkLoginToken($scope.credentials.email, $scope.credentials.token, function(data) {
            console.log(data)
            if (data.error) {
                if (data.error == "30") {
                    $scope.error("Du wurdest aus Sicherheitsgründen ausgeloggt, bitte gib deine Login-Daten ein")
                    $scope.showCredentials = false;
                }
            }
            else {
                window.location.replace("./start.php");
            }
        })
    }

    checkCredentials()

    $scope.error = function(msg) {
        //console.log(Notification)
        AtlasNotification.error(msg);
    };

    $scope.loginError = function(msg) {
        //console.log(Notification)
        AtlasNotification.error({ message: msg, actionText: "Passwort vergessen", actionHandler: $scope.openForgottPasswordDialog, timeout: 6000 });
    };

    $scope.charInput = function(e) {
        if (e.key == "Enter") {
            $("#loginButton").click()
        }
    }

    $rootScope.$on("showEmailHint", function() {
        $scope.showEmailHint = true;
    })

    $scope.openTFAHelp = function(){
        throw new Error("not yet implemented");    
    }
    
    $scope.redirectToStartPage = function(){
        window.location = "/overview";
    }
    
    $scope._sendLoginRequest = function(data) {
        networkService.callOperation("login", data, function(response) {
            data = response.getData()
            if (data.state == 1) {
                AtlasNotification.error({ message: "Login erfolgreich."});
                $scope.redirectToStartPage();
            }
            else if (data.state == 2) {
                AtlasNotification.error({ message: "Bitte gib den Code ein.", actionText: "Hilfe", actionHandler: $scope.openTFAHelp, timeout: 4000 });
                $scope.state = 2;
                $scope.gui.tfa.visible = true;
                $scope.gui.password.disabled = true;
                $scope.gui.email.disabled = true;
            }else if(data.state == 4) {
                AtlasNotification.error({ message: "Bitte klick auf den Bestätigungslink in der E-Mail.", actionText: "Erneut senden", actionHandler: $scope.openTFAHelp, timeout: 4000 });
            }
            else {
                $scope.loginError("Falsche Logindaten")
            }
        });
    }

    $scope._sendTFARequest = function(code) {
        var data = {code:code};
        networkService.callOperation("twoFa", data, function(response) {
            data = response.getData()
            console.log(data)
            if (data.state == 1) {
                AtlasNotification.error({ message: "Login erfolgreich."});
                $scope.redirectToStartPage();
            }
            else if (data.state == 3) {
                 AtlasNotification.error({ message: "Falscher Code", actionText: "Hilfe", actionHandler: $scope.openTFAHelp, timeout: 4000 });
            }
            else {
                $scope.loginError("Undefinierter Fehler")
            }
        });
    }

    $scope.login = function(token) {

        if ($scope.state == 1) {
            var email = $scope.email
            var password = $scope.loginPassword
            var data = {
                email: email,
                password: password,
                token:token
            }
            $scope._sendLoginRequest(data)
        }
        else if ($scope.state == 2) {
            var code = $scope.tfaCode;
            $scope._sendTFARequest(code);
        }

    }
    $scope.init()
}])
